import RoleAssignmentHashTableTypes from "src/pages/hr/Types/RoleAssignmentHashTableTypes"
import roleAssignmentHelper from "./RoleAssignmentHelper"

const handleAddOrDropEdit = (bucketItem: RoleAssignmentHashTableTypes, operation?: "+" | "-" | "all" | "!all") => {
    let temp = bucketItem
    let tempAt1 = temp[1]

    if (operation) {

        if (!tempAt1.hasEdit && operation === "+") {
            tempAt1.dropEdit = false
            tempAt1.addEdit = true
        } else if (operation === "-") {
            tempAt1.dropEdit = true
            tempAt1.addEdit = false
        }
        else if (operation === "all") {
            tempAt1.dropEdit = false
            if (!tempAt1.hasEdit) {
                tempAt1.addEdit = true
            }
        }
        else if (operation === "!all") {
            tempAt1.dropEdit = false
            if (tempAt1.hasEdit) {
                tempAt1.dropEdit = true
            }
            tempAt1.addEdit = false
        }

    } else {

        if (tempAt1.hasEdit && !tempAt1.dropEdit) {
            tempAt1.dropEdit = true
        } else if (tempAt1.hasEdit && tempAt1.dropEdit) {
            tempAt1.dropEdit = false
        }

        if (!tempAt1.hasEdit && !tempAt1.addEdit) {
            tempAt1.addEdit = true
        } else if (!tempAt1.hasEdit && tempAt1.addEdit) {
            tempAt1.addEdit = false
        }
    }

    temp[1] = tempAt1
    roleAssignmentHelper.updateHashTableItem(temp)
    const storage = roleAssignmentHelper.getStorage()
    return storage
}

export default handleAddOrDropEdit